import { Key } from '../core/key';
import { MethodDecorator, Type } from '../reflection/types';
import { ComponentBase } from './component-base';
import { ComponentData } from './component-data';

export const KeyDownListener = (key: Key , selector?: string): MethodDecorator => {
    return (target: { constructor: Type<ComponentBase<any>> }, propertyKey: string, descriptor: PropertyDescriptor) => {
        ComponentData.registerEventListener(target.constructor, propertyKey, selector, 'keydown', (e: Event) => (e as KeyboardEvent).key == key);
    };
}